/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import {
  TextField,
  MenuItem,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  autoFormateDate,
  fromQtrToDT,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import {
  dispatchQtrRange,
  dispatchErrorMsgCMS,
  dispatchPerformResolutionObj,
  getPlanTypeValues,
  getRebateProgramLists,
  dispatchRebateProgramName,
  getCmsRebateGroup,
  dispatchCmsRebateGroupName,
  getSelectedOption,
  getCmsRebateGroupListData,
  dispatchCmsRebateGroupNameList,
  getCmsReportingData,
  dispatchDisplayObjQuarterlyReporting,
  dispatchCmsRebateGroupList,
  getMaxQtr,
  getCmsRebateGroupFindFreezeQtrByRpc,
  getCMSRptAdjSingleRpcQtr,
  getCMSRptGrpRpcQtr,
  dispatchFlag
} from '../Store/action';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import {
  checkQuarterValidation,
  handleScrollToEvent,
  quarterTest1,
  quarterTest2,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';

import {
  REBATE_PROGRAM_REQUIRED,
  STATUS_MSG,
  SUCCESS_MSG,
  QUARTER_VALUE_REQUIRED,
  VALIDATE_QUARTER_VALUE,
  REBATE_REPORTING_REQUIRED,
} from '../../../../SharedModules/Errors/constantMessageData';

import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';
import GroupOfRebateProgramComponent from '../../../../SharedModules/CustomGroupOfRebateProgram/GroupOfRebateProgramComponent';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import showPreloader from '../../../../interceptor/store/Actions';


const ReqQuarterlyReporting = (props) => {
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const {
    performResolutionObj: requestCurrentDisData,
    planType: planTypeList,
    listRebateGroup: getRebateGroupList,
    errorMsgCMS: getErrorMsg,
    rebateGroup: getCmsRebateGroupList,
    startQtr: startQtrValue,
    rebateCategoryValue,
    rebateGroupCategoryValue,
    selectedOptionValue,
    mxQtr,
    quarterlyReporting: getReportingData,
  } = useSelector((state) => state?.sharedState?.CMSQuarterlyReducer);

  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });

  const [radioList, setRadioList] = React.useState([]);
  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  const [rebateList, setRebateList] = React.useState([]);
  const [rebateGroupList, setRebateGroupList] = React.useState([]);
  const dispatch = useDispatch();
  const [startQtr, setStartQtr] = React.useState(startQtrValue);
  const [selectedOption, setSelectedOption] =
    React.useState(selectedOptionValue);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [isSearchClicked, setSearchClicked] = React.useState(false);
  const [isApiSearchClicked, setApiSearchClicked] = React.useState(false);
  const [popupQtr, setPopupQtr] = React.useState('');
  const [open, setOpen] = React.useState(false);
    
  
  // local variable
  const [state, setState] = React.useState(
    requestCurrentDisData?.state || {
      planTypeCd: userDefaults?.planTypeCd ? userDefaults?.planTypeCd : 'FD',
      rebateProgramCd: userDefaults?.rebateProgramCd || '-1',
      quarter: '',
      rebateCategory: rebateCategoryValue,
      rebateGroupCategory: rebateGroupCategoryValue,
    }
  );
  // dispatch function
  const setPerformScrData = (value) =>
    dispatch(dispatchPerformResolutionObj(value));

  // fullscreen functionality
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
    setPerformScrData({
      fullScreenView: !fullScreenView,
      state: state,
    });
  };
  // Plan type useEffect
  React.useEffect(() => {
    handleScrollToEvent();
    if (!planTypeList?.PLAN_TYPE_CD) {
      dispatch(getPlanTypeValues({}));
    }
    if (startQtrValue && checkQuarterValidation(startQtrValue)) {
      fetchGroupOfRebateProgramList(startQtrValue);
    }

  }, []);
  const rebatepgmDropdown = async (planType) => {
    const rebateProgramDataList = await dispatch(
      getRebateProgramLists(planType)
    );
    let list = [];
    if (
      rebateProgramDataList?.status === STATUS_MSG &&
      rebateProgramDataList?.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(rebateProgramDataList.data)) {
        list = _.map(rebateProgramDataList.data, (val) => ({
          ...val,
          id: val.rebateProgramCd,
          name: `${val.shortDescr}`,
        }));
      }
    }
    setRebateProgramList(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  };
  //  setting radioList from planList Api
  React.useEffect(() => {
    if (
      planTypeList &&
      planTypeList.PLAN_TYPE_CD &&
      planTypeList.PLAN_TYPE_CD.length > 0
    ) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
    }
  }, [planTypeList]);
  // get rebate program
  React.useEffect(() => {
    rebatepgmDropdown(state.planTypeCd);
  }, [state.planTypeCd]);

  // on change event on filed
  const handleOnChangeEvent = (value, name) => {
    let localErr = getErrorMsg || [];
    localErr = localErr.filter(err => err.field !== 'noData');
    if (name === 'planTypeCd') {
      setState({ ...state, [name]: value, rebateProgramCd: '-1' });
      setPerformScrData({
        state: { ...state, planTypeCd: value, rebateProgramCd: '-1' },
      });
    }
    if (name === 'rebateProgramCd') {
      setState({ ...state, [name]: value });
      setPerformScrData({
        state: { ...state, [name]: value },
      });
    }
    localErr = localErr.filter((item) => item.field != 'rebateProgramCd');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgCMS(unique));
  };
  const handleOnblurEvent = (type, value) => {
    let localErr = getErrorMsg || [];
    localErr = localErr.filter(err => err.field !== 'noData');
    const data = value;
    if (type === 'rebateProgramCd') {
      localErr = localErr?.filter((item) => item.field !== 'rebateProgramCd');
    }
    if (type === 'rebateCategory') {
      if (!value || value === '-1') {
        localErr = localErr?.filter((item) => item.field !== 'reportingGroup');
        localErr.push({
          field: 'reportingGroup',
          errorType: 'reportingGroup',
          message: REBATE_REPORTING_REQUIRED,
        });
      } else {
        localErr = localErr.filter((item) => item.field !== 'reportingGroup');
      }
    }
    if (type === 'rebateGroupCategory') {
      if (!value || value === '-1') {
        localErr = localErr?.filter((item) => item.field !== 'rebateProgramCd');
        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'rebateRequired',
          message: REBATE_PROGRAM_REQUIRED,
        });
      } else {
        localErr = localErr?.filter((item) => item.field !== 'rebateProgramCd');
      }
    }
    if (type === 'quarter') {
      if (data && !_.isEmpty(data) && !_.isNaN(data)) {
        const indexOf = !_.isEmpty(localErr)
          ? _.findIndex(localErr, {
              field: 'quarter',
              errorType: 'required',
            })
          : null;

        if (!_.isNull(indexOf) && indexOf >= 0) {
          localErr.splice(indexOf, 1);
        }
        if (quarterTest1.test(data) || quarterTest2.test(data)) {
          const indexOf = !_.isEmpty(localErr)
            ? _.findIndex(localErr, {
                field: 'quarter',
                errorType: 'invalidFormat',
              })
            : null;

          if (!_.isNull(indexOf) && indexOf >= 0) {
            localErr.splice(indexOf, 1);
          }
          localErr = localErr.filter((item) => item.field !== 'quarter');
          setState({
            ...state,
            quarterValue: autoFormateDate(value?.toUpperCase()),
          });
          setPerformScrData({
            state: {
              ...state,
              quarterValue: autoFormateDate(value?.toUpperCase()),
            },
          });
        } else {
          localErr = localErr.filter((item) => item.field !== 'quarter');
          localErr.push({
            field: 'quarter',
            errorType: 'invalidFormat',
            message: VALIDATE_QUARTER_VALUE,
          });
        }
      } else {
        localErr = localErr.filter((item) => item.field !== 'quarter');
        if (type === 'quarter') {
          localErr.push({
            field: 'quarter',
            errorType: 'required',
            message: QUARTER_VALUE_REQUIRED,
          });
        }
      }
    }

    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgCMS(unique));
  };
  // Rebate programe error on plan type change
  React.useEffect(() => {
    handleOnblurEvent('rebateProgramCd', '1');
  }, [state.planTypeCd]);
React.useEffect(() => {
  if (state.rebateProgramCd && state.rebateProgramCd !== '-1') {
    if (selectedOption === 'Single') {
      dispatch(getCMSRptAdjSingleRpcQtr({ rebateProgramCd: state.rebateProgramCd }));
    } else if (selectedOption === 'Group') {
      dispatch(getCMSRptGrpRpcQtr({ rebateProgramCd: state.rebateProgramCd }));
    }
  }
}, [state.rebateProgramCd, selectedOption, dispatch]);

React.useEffect(() => {
  if (mxQtr && typeof mxQtr === 'string') {
    // No need to add +1 again here
    handleOnblurEvent('quarter', mxQtr);
    setStartQtr(mxQtr);
    dispatch(dispatchQtrRange({ startQtr: mxQtr }));
  }
}, [mxQtr, dispatch]);


  //  tab highliter Functionality
  React.useEffect(() => {
    if (getErrorMsg && getErrorMsg.length > 0) {
      tabHighLigther('/CMSQuarterlyReporting', true);
    } else {
      tabHighLigther('/CMSQuarterlyReporting', false);
    }
  }, [JSON.stringify(getErrorMsg)]);
  const [overrideMaxQtrCheck, setOverrideMaxQtrCheck] = React.useState(false);

  // Search button on click functionality
  const onClickOnSearch = async() => {
    setApiSearchClicked(false);
    dispatch(dispatchFlag(false));
    const rebateProgramName = rebateProgramList.find(
      (item) => item.id == state.rebateProgramCd
    );
    if (
      !overrideMaxQtrCheck && mxQtr &&
      new Date(fromQtrToDT(startQtr)) > new Date(fromQtrToDT(mxQtr))
    ) {
      setPopupQtr(mxQtr);
      setOpen(true);
      dispatch(showPreloader(false));
      return;
    }
    const groupNameData = state?.rebateCategory
      ? rebateGroupList?.filter((x) => {
          return x.id === state?.rebateCategory;
        })[0]
      : {};
    let localErr = getErrorMsg || [];
    if (state.rebateProgramCd === '-1' && selectedOption === 'Single') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: REBATE_PROGRAM_REQUIRED,
      });
    }
    if (!startQtr) {
      localErr =
        localErr && localErr?.filter((item) => item.field !== 'quarter');
      localErr.push({
        field: 'quarter',
        errorType: 'required',
        message: QUARTER_VALUE_REQUIRED,
      });
    }
    if (
      (state?.rebateCategory === '' || state?.rebateCategory === '-1') &&
      selectedOption === 'Group'
    ) {
      localErr = localErr.filter((item) => item.field !== 'reportingGroup');
      localErr.push({
        field: 'reportingGroup',
        errorType: 'reportingGroup',
        message: REBATE_REPORTING_REQUIRED,
      });
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgCMS(unique));
    if (selectedOption == 'Single' && localErr.length == 0) {
      // if (state.rebateProgramCd != '-1' && quarterTest1.test(startQtr))
      if (state.rebateProgramCd != '-1' && startQtr != '') {
        setSearchClicked(true);
        dispatch(
          getCmsReportingData({
            quarter: startQtr,
            rebateProgram: [rebateProgramName?.rebateProgramCd],
          })
        );
        dispatch(dispatchRebateProgramName(rebateProgramName));
        dispatch(dispatchQtrRange({ startQtr }));

        dispatch(getSelectedOption({ selectedOptionValue: selectedOption }));
        dispatch(
          dispatchCmsRebateGroupName({
            rebateGroupCategoryValue: state?.rebateGroupCategory,
          })
        );
        dispatch(
          dispatchCmsRebateGroupNameList({
            rebateCategoryValue: state?.rebateCategory,
          })
        );
        dispatch(
          dispatchDisplayObjQuarterlyReporting({
            rebateProgramName,
            groupOfRebateProgramList: getRebateGroupList?.data,
            rebateCategoryValue: state?.rebateCategory,
            rebateGroupCategoryValue: state?.rebateGroupCategory,
            selectedOptionValue: selectedOption,
            startQtr,
          })
        );
      }
    } else if (localErr.length === 0) {
      setSearchClicked(true);
      dispatch(
        getCmsReportingData({
          quarter: startQtr,
          rebateProgram: getRebateGroupList?.data?.map((item) => {
            return item.rebateProgramCd;
          }),
        })
      );
      dispatch(dispatchRebateProgramName(rebateProgramName));
      dispatch(dispatchQtrRange({ startQtr }));
      dispatch(getSelectedOption({ selectedOptionValue: selectedOption }));

      dispatch(
        dispatchCmsRebateGroupName({
          rebateGroupCategoryValue: state?.rebateGroupCategory,
        })
      );
      dispatch(
        dispatchCmsRebateGroupNameList({
          rebateCategoryValue: state?.rebateCategory,
        })
      );
      dispatch(
        dispatchDisplayObjQuarterlyReporting({
          rebateProgramName,
          groupOfRebateProgramList: getRebateGroupList?.data,
          rebateCategoryValue: state?.rebateCategory,
          rebateGroupCategoryValue: state?.rebateGroupCategory,
          selectedOptionValue: selectedOption,
          startQtr,
        })
      );
    }
  };
  if (isSearchClicked && getReportingData?.column1?.length > 0) {
    setSearchClicked(false);
    sessionStorage.setItem('fromSearch', 'true');

    redirectURLLink(
      '/DisplayCMSQuarterlyReporting',
      'Display Summary Report CMS64',
      props.history
    );
    dispatch(clearReduxForFilterAndSort('/DisplayCMSQuarterlyReporting'));
  }
  // converting mm/dd/yyyy to mQyyyy
  function convertDateRange(dateRange) {
    const dates = dateRange.split(' - ');
    const startDate = new Date(dates[0]);

    const startQuarter = Math.floor(startDate.getMonth() / 3 + 1);
    const startYear = startDate.getFullYear();

    const formattedString = `${startQuarter}Q${startYear}`;

    return formattedString;
  }
  // converting startQtr to required format
  function convertInput(input) {
    const datePattern = /\d{2}\/\d{2}\/\d{4}/;
    const quarterPattern = /\dQ\d{4}/;

    if (datePattern.test(input)) {
      return convertDateRange(input);
    }
    return input;
  }
  // rebate Group
  React.useEffect(() => {
    let data1 = getCmsRebateGroupList?.data?.map((item) => {
      return {
        ...item,
        name: item,
        id: item,
      };
    });
    setRebateGroupList(data1);
    if (getCmsRebateGroupList?.message === 'SUCESS' && isApiSearchClicked) {
      onClickOnSearch();
    }
  }, [getCmsRebateGroupList]);

  const fetchGroupOfRebateProgramList = (val) => {
    if (checkQuarterValidation(val)) {
      dispatch(
        getCmsRebateGroup({
          utilQtr: convertInput(val),
        })
      );
      const payload = {
        quarter: val,
        rebateProgramCode: state.rebateProgramCd,
      };
      dispatch(getCmsRebateGroupFindFreezeQtrByRpc(payload));
    }
  };
  const fetchAllRebateProgramWithGroup = (val) => {
    if (val) {
      dispatch(
        getCmsRebateGroupListData({
          quarter: convertInput(startQtr),
          rebateProgramCode: val,
        })
      );
    }
  };

  // list of group rebate

  React.useEffect(() => {
    const data2 = getRebateGroupList?.data?.map((item) => {
      return {
        ...item,
        name: `${item.rebateProgramCode} | ${item.shortDesc}`,
        id: `${item.rebateProgramCode} | ${item.shortDesc}`,
      };
    });

    setRebateList(data2);
    setState({
      ...state,
      rebateGroupCategory: data2?.[0]?.name,
    });
  }, [getRebateGroupList]);

  // setting Quarter From
  const handleFromChange = (event) => {
    let { value } = event.target;
    if (value?.includes('q')) {
      value = value?.replace('q', 'Q');
    }
    setStartQtr(value);
    let localErr = getErrorMsg || [];
    //localErr = localErr.filter((item) => item.field !== 'quarter');
    localErr = localErr.filter(
      err => err.field !== 'noData' && err.field !== 'quarter'
    );
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgCMS(unique));
  };
  React.useEffect(() => {
  setOverrideMaxQtrCheck(false);
}, [startQtr, state.rebateProgramCd]);
  return (
    <>
      <div className="tabs-container">
        <Spinner load={spinnerLoader} />
        <CustomSeparator parent1="CMS" parent2="CMS Quarterly Reporting" />
        <DisplayErrorMessages
          errorMessages={[
            ...new Set(
              getErrorMsg?.length > 0
                ? _.map(getErrorMsg, (l) => l.message)
                : []
            ),
          ]}
        />

        <div className="tab-body">
          <CommonModal
            open={open}
            viewAction
            className='dialog-420'
            viewHeader
            onOk={() => {
              setOpen(false);
              setOverrideMaxQtrCheck(true);
              onClickOnSearch(); 
            }}
            okTitle='Ok'
            onClose={() => setOpen(false)}
            modalTitle='CMS Quarterly Reporting'
            childrenComponent={`Quarter entered cannot be greater than quarter ${popupQtr}`}
          />
          
          {!fullScreenView && (
            <>
              <div className="row">
                <div className="col-8 frr-two-col-radio">
                  <fieldset className="custom-fieldset">
                    <legend className="same-font-family">
                      Selected By<span className="mandatory"> *</span>
                    </legend>
                    <div className="form-wrapper p-3">
                      <div className="mui-custom-form with-select field-xl no-lbl">
                        <RadioGroup
                          row
                          name="report-quarter"
                          required
                          data-testid="cms64-radio-button"
                          value={selectedOption}
                          onChange={(e) => {
                            setSelectedOption(e.target.value);
                            setState({
                              ...state,
                              rebateCategory: '-1',
                            });
                            dispatch(
                              getSelectedOption({
                                selectedOptionValue: e.target.value,
                              })
                            );
                            setPerformScrData({
                              state: { ...state, rebateCategory: '-1' },
                            });
                            let localErr = getErrorMsg || [];
                            localErr = localErr.filter(
                              err => err.field !== 'noData' && err.field !== 'rebateProgramCd' && err.field !== 'reportingGroup'
                            );
                            const unique = [...new Set(localErr)];
                            dispatch(dispatchErrorMsgCMS(unique));
                          }}
                        >
                          <FormControlLabel
                            // style={{ marginRight: '10px' }}
                            value="Single"
                            control={<Radio />}
                            label="Single Rebate Program"
                          />
                          <FormControlLabel
                            // style={{ marginRight: '10px' }}
                            value="Group"
                            control={<Radio />}
                            label="Group of Rebate Programs"
                          />
                        </RadioGroup>
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div className="col-4">
                  <fieldset className="custom-fieldset">
                    <legend className="same-font-family">
                      Quarter<span className="mandatory"> *</span>
                    </legend>
                    <div className="form-wrapper p-0">
                      <div className="mui-custom-form with-select field-xl no-lbl">
                        <TextField
                          data-testid="cms64-check_by_invoice_quater"
                          id="check_by_invoice_quater"
                          label="check_by_invoice_quater"
                          required
                          fullWidth
                          value={startQtr}
                          onChange={handleFromChange}
                          placeholder=""
                          inputProps={{ maxLength: 6 }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          className={
                            getErrorMsg?.length > 0
                              ? _.map(getErrorMsg, (l) =>
                                  l.field == 'quarter' ? 'mandate-fields' : null
                                )
                              : null
                          }
                          onBlur={(e) => {
                            const value = autoFormateDate(e?.target?.value);
                            setStartQtr(value);
                            handleOnblurEvent(
                              'quarter',
                              e?.target?.value?.toUpperCase()
                            );
                            dispatch(dispatchQtrRange({ startQtr: value }));
                            if (selectedOption === 'Group') {
                              fetchGroupOfRebateProgramList(startQtr);
                            }
                            setState({
                              ...state,
                              rebateCategory: '-1',
                            });
                            setPerformScrData({
                              state: { ...state, rebateCategory: '-1' },
                            });
                            dispatch(dispatchCmsRebateGroupList([]));
                            setRebateGroupList([]);
                          }}
                          helperText={
                            getErrorMsg?.length > 0
                              ? _.map(getErrorMsg, (l) =>
                                  l.field === 'quarter' ? l.message : null
                                )
                              : null
                          }
                          error={
                            getErrorMsg?.length > 0
                              ? _.map(getErrorMsg, (l) =>
                                  l.field == 'quarter' ? l.message : null
                                )
                              : null
                          }
                        />
                      </div>
                    </div>
                  </fieldset>
                </div>
                {selectedOption == 'Single' && (
                  <div className="col-4 frr-two-col-radio">
                    <RadioGroupComponent
                      data-testid="radio-button-for-rcdd"
                      id="radio-button-for-rcdd_id"
                      labelName="Plan Type"
                      required
                      optionList={radioList || []}
                      defaultValue={state && state.planTypeCd}
                      filterAction={(e) => {
                        handleOnChangeEvent(e, 'planTypeCd');
                      }}
                      className="log-batch-filter-radio frr-checkInvoiceRadio"
                    />
                  </div>
                )}
                {selectedOption == 'Single' && (
                  <div className="col-4 frr-two-col-radio ">
                    <fieldset className="custom-fieldset">
                      <legend className="same-font-family">
                        Rebate Program<span className="mandatory"> *</span>
                      </legend>
                      <div className="form-wrapper p-3">
                        <div className="mui-custom-form with-select field-xl no-lbl">
                          <TextField
                            name="rebateProgram"
                            id="rebate_program"
                            label="Rebate Program 123"
                            data-testid="cms64-rebate-program"
                            style={{ color: '#000' }}
                            fullWidth
                            select
                            required
                            inputProps={{ maxLength: 11, id: 'rebate_program' }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            className={
                              getErrorMsg?.length > 0
                                ? _.map(getErrorMsg, (l) =>
                                    l.field === 'rebateProgramCd'
                                      ? 'mandate-fields'
                                      : null
                                  )
                                : null
                            }
                            onBlur={(e) =>
                              handleOnblurEvent(
                                'rebateProgramCd',
                                e?.target?.value
                              )
                            }
                            onChange={(e) =>
                              handleOnChangeEvent(
                                e.target.value,
                                'rebateProgramCd'
                              )
                            }
                            value={
                              state && state.rebateProgramCd
                                ? state.rebateProgramCd
                                : ''
                            }
                            error={
                              getErrorMsg?.length > 0
                                ? _.map(getErrorMsg, (l) =>
                                    l.field === 'rebateProgramCd'
                                      ? l.message
                                      : null
                                  )
                                : null
                            }
                            helperText={
                              getErrorMsg?.length > 0
                                ? _.map(getErrorMsg, (l) =>
                                    l.field === 'rebateProgramCd'
                                      ? l.message
                                      : null
                                  )
                                : null
                            }
                          >
                            <MenuItem
                              key=""
                              value="-1"
                              className="frr-dropdown-blank-item"
                            />
                            {rebateProgramList?.length > 0
                              ? rebateProgramList?.map((item) => {
                                  return (
                                    <MenuItem key={item.id} value={item.id} className="frr-logcheck-dropdown-item">
                                      {`${item.id} | ${item.name}`}
                                    </MenuItem>
                                  );
                                })
                              : null}
                          </TextField>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                )}
                {selectedOption === 'Group' && (
                  <div className="col-8 frr-two-col-radio ">
                    <fieldset className="custom-fieldset">
                      <legend className="same-font-family">
                        CMS Reporting Group<span className="mandatory"> *</span>
                      </legend>
                      <div className="form-wrapper p-3">
                        <div className="mui-custom-form with-select field-xl no-lbl">
                          <TextField
                            name="reporting_group"
                            id="reporting_group"
                            label="CMS Reporting Group"
                            data-testid="cms64-reporting-group"
                            fullWidth
                            select
                            required
                            inputProps={{
                              maxLength: 11,
                              id: 'reporting_group',
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            onChange={(e) => {
                              fetchAllRebateProgramWithGroup(e.target?.value);
                              setState({
                                ...state,
                                rebateCategory: e.target.value,
                              });
                              setPerformScrData({
                                state: {
                                  ...state,
                                  rebateCategory: e.target.value,
                                },
                              });
                            }}
                            onBlur={(e) => {
                              let localErr = getErrorMsg || [];
                              if (!e.target.value || e.target.value === '-1') {
                                localErr = localErr?.filter(
                                  (item) => item.field !== 'reportingGroup' && item.field !== 'noData'
                                );
                                localErr.push({
                                  field: 'reportingGroup',
                                  errorType: 'reportingGroup',
                                  message: REBATE_REPORTING_REQUIRED,
                                });
                              } else {
                                localErr = localErr.filter(
                                  (item) => item.field !== 'reportingGroup' && item.field !== 'noData'
                                );
                              }
                              const unique = [...new Set(localErr)];
                              dispatch(dispatchErrorMsgCMS(unique));
                            }}
                            value={state.rebateCategory}
                            className={
                              getErrorMsg?.length > 0
                                ? _.map(getErrorMsg, (l) =>
                                    l.field == 'reportingGroup'
                                      ? 'mandate-fields'
                                      : null
                                  )
                                : null
                            }
                            error={
                              getErrorMsg?.length > 0
                                ? _.map(getErrorMsg, (l) =>
                                    l.field === 'reportingGroup'
                                      ? l.message
                                      : null
                                  )
                                : null
                            }
                            helperText={
                              getErrorMsg?.length > 0
                                ? _.map(getErrorMsg, (l) =>
                                    l.field === 'reportingGroup'
                                      ? l.message
                                      : null
                                  )
                                : null
                            }
                          >
                            <MenuItem
                              key=""
                              value="-1"
                              className="frr-dropdown-blank-item"
                            />
                            {rebateGroupList?.length > 0
                              ? rebateGroupList
                                  ?.filter((x) => {
                                    return x.id !== '-1';
                                  })
                                  ?.map((item) => {
                                    return (
                                      <MenuItem key={item.id} value={item.id} className="frr-logcheck-dropdown-item">
                                        {item.name}
                                      </MenuItem>
                                    );
                                  })
                              : null}
                          </TextField>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                )}
                {selectedOption === 'Group' && (
                  <div className="col-4 btn-wrapper mt-5">
                    <div className="float-right hide-on-print">
                      <Button
                        className="btn btn-success btn-search"
                        data-testid="view_detail_ia"
                        type="button"
                        onClick={onClickOnSearch}
                      >
                        {' '}
                        <SVGComponent iconName="Icon-search" /> {'  '} Search
                      </Button>
                    </div>
                  </div>
                )}
              </div>
              {selectedOption !== 'Group' && (
                <div className="col-12 btn-wrapper mb-2">
                  <div className="float-right mt-2 hide-on-print">
                    <Button
                      className="btn btn-success btn-search"
                      data-testid="view_detail_ia"
                      type="button"
                      onClick={() => {
                        setApiSearchClicked(true);
                        fetchGroupOfRebateProgramList(startQtr);
                      }}
                    >
                      {' '}
                      <SVGComponent iconName="Icon-search" /> {'  '} Search
                    </Button>
                  </div>
                </div>
              )}
            </>
          )}
          {selectedOption === 'Group' && (
            <div className="panel-body FRR-custom-table tbl-manufacturer-inner frr-log_chk">
              <GroupOfRebateProgramComponent
                fullScreenView={fullScreenView}
                handleFullScreenView={handleFullScreenView}
                data={
                  state?.rebateCategory !== '' && state?.rebateCategory !== '-1'
                    ? getRebateGroupList?.data?.map((item) => {
                        item.rebateProgramCd = item.rebateProgramCode;
                        item.shortDescr = item.shortDesc;
                        return item;
                      })
                    : []
                }
                fileName="G-Rebate Program Grid"
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ReqQuarterlyReporting;
